<div
  (click)="canOpenProfile ? openProfileHandler($event) : null"
  [class]="avatarSize"
  [ngClass]="{ 'hover-style': canOpenProfile }"
  [pTooltip]="showTooltips ? (isUnknownUser ? unknownUserMessage : avatarTooltip) : ''"
  [tooltipPosition]="isUnknownUser ? 'left' : 'top'"
>
  @if (imageUrl) {
    <div class="avatar" [ngStyle]="{ background: 'url(' + imageUrl + ')' }">
      <div
        class="hover-overlay"
        [ngClass]="{ 'hover-disabled': !canOpenProfile }"
        data-testId="db-ui--user-avatar"
        [pTooltip]="showUserNameTooltip ? fullName : ''"
        tooltipPosition="left"
      ></div>
    </div>
  } @else if (!userInfo?.firstName && !userInfo?.lastName && !name) {
    <!-- NN user: no name information available -->
    <div class="unknown-user">
      <db-svg-icon path="/assets/icons/user_circle_gray.svg" [class]="avatarSize | convertAvatarToUserIconSize" />
      <div
        class="hover-overlay"
        [ngClass]="{ 'hover-disabled': !canOpenProfile }"
        data-testId="db-ui--user-avatar-nn"
      ></div>
    </div>
  } @else {
    <div
      class="initials"
      [ngStyle]="{
        background: userInfo?.avatarColor || userInfo?.color || '#A5A5A5',
      }"
    >
      {{ name || userInfo?.firstName + " " + userInfo?.lastName | exec: getAbbreviation }}
      <div
        class="hover-overlay"
        [ngClass]="{ 'hover-disabled': !canOpenProfile }"
        data-testId="db-ui--user-avatar"
        [pTooltip]="showUserNameTooltip ? fullName : ''"
        tooltipPosition="left"
      ></div>
    </div>
  }

  <ng-template #initials>
    <div
      class="initials"
      [ngStyle]="{
        background: userInfo?.avatarColor || userInfo?.color || '#A5A5A5',
      }"
    >
      {{ name || userInfo?.firstName + " " + userInfo?.lastName | exec: getAbbreviation }}
      <div
        class="hover-overlay"
        [ngClass]="{ 'hover-disabled': !canOpenProfile }"
        data-testId="db-ui--user-avatar"
      ></div>
    </div>
  </ng-template>

  @if (showFavUserIcon && userInfo?.followingStatus === FollowingStatusType.FOLLOWING) {
    <div class="favorite-star">
      <db-svg-icon
        [class]="['db-icon-active-hover', avatarSize | convertAvatarToBadgeIconSize]"
        path="/assets/icons/purple-star.svg"
      />
    </div>
  }
</div>
